import React, {Component} from 'react';
import {connect} from "react-redux";

import axios from 'axios';
import swal from 'sweetalert2';
import {Link} from 'react-router-dom';
import NotificationSystem from 'react-notification-system';

import urls from '../../utils/urls';
import {tokenHeader} from "../../utils/headers";
import {Spinner} from "../../components/Loading/Spinner";
import {ajaxHandler} from "../../utils/errors";


class PasswordReset extends Component {

    constructor(props){
        super(props);

        this.state = {
            password: '',
            new_password1: '',
            new_password2: '',
            ajaxInProgress: false,
            _notificationSystem: null
        }
    }

    componentDidMount(){
        this.setState({_notificationSystem: this.refs.notificationSystem});

        // Check if user is old. If so, logout just in case
        const user = JSON.parse(localStorage.getItem('activeUser'));
        if(user){
            let now = new Date().getTime();
            if(now - user.token_date > (1*24*60*60*1000)){
                localStorage.clear();
                window.location = '/';
            }
        }

    }

    _handleInput = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleSubmit = (ev) => {
        ev.preventDefault();

        let {password, new_password1, new_password2} = this.state;

        if(password === '' || new_password1 === '' || new_password2 === ''){
            this.state._notificationSystem.addNotification({
                title: 'Formulario incompleto',
                message: 'Por favor, complete todos los campos para continuar.',
                level: 'error',
                position: 'bc',
                dismissible: true
            });
            return false;
        }

        if(new_password1 !== new_password2){
            this.state._notificationSystem.addNotification({
                title: 'Error en la nueva contraseña',
                message: 'Las contraseñas ingresadas no coinciden.',
                level: 'error',
                position: 'bc',
                dismissible: true
            });
            return false;
        }

        if(password === new_password1){
            this.state._notificationSystem.addNotification({
                title: 'Error en la nueva contraseña',
                message: 'La nueva contraseñaa ingresada no puede ser igual a la actual.',
                level: 'error',
                position: 'bc',
                dismissible: true
            });
            return false;
        }

        this.setState({ajaxInProgress: true});

        const reset_url = `${urls.API_ROOT}/api/v1/password/change/`;
        axios.post(reset_url, {password, new_password1, new_password2}, tokenHeader())
            .then(() => {

                swal({
                    title: 'Contraseña actualizada',
                    html: 'Su contraseña ha sido actualizada correctamente. Espere unos segundos por favor.',
                    type: 'success',
                    showConfirmButton: false,
                    timer: 3000
                });

                setTimeout(() => this.props.history.push('/logout'), 3000);
            })
            .catch((error) => {
                this.setState({ajaxInProgress: false});
                try{
                    let response = error.response;
                    if(response.status === 400){
                        let details = "";
                        if(response.data.error){
                            response.data.error.forEach(e => {
                                details = details + `• ${e}. `
                            });
                        }else{
                            response.data.forEach(e => {
                                details = details + `• ${e}. `
                            });
                        }
                        this.state._notificationSystem.addNotification({
                            title: 'Error en la actualización de contraseña',
                            message: `Se encontraron los siguientes errores: ${details}`,
                            level: 'error',
                            position: 'bc',
                            dismissible: true
                        });
                    }else if(response.status === 401){
                        this.state._notificationSystem.addNotification({
                            title: 'Contraseña incorrecta',
                            message: 'Su contraseña actual es incorrecta',
                            level: 'error',
                            position: 'bc',
                            dismissible: true
                        });
                    }else{
                        ajaxHandler(error);
                    }
                }
                catch (e){
                    console.log(e);
                    ajaxHandler(error);
                }
            })
    };

    render() {

        let forcedRoute = (this.props.user && this.props.user.needs_password_reset);

        let title = 'Cambiar de contraseña';
        let body = (
            <div className={'row'}>
                <p className="text-left shell-lightgrey-text padding-10" style={{fontSize: 16}}>
                    Usted está por actualizar su contraseña para todas las herramientas vinculadas.
                    <br />
                    Por favor, complete el formulario a continuación
                </p>
            </div>
        );
        if (forcedRoute) {
            title = 'Actualización de contraseña';
            body = (
                <div className={'row'}>
                    <p className="text-left shell-lightgrey-text padding-10" style={{fontSize: 16}}>
                        Su contraseña actual ha expirado y debe crear una nueva.
                        <br />
                        Por favor, complete el formulario a continuación
                    </p>
                </div>
            );
        }


        return (
            <div>
                <div className="valign-wrapper main-login">
                    <div className="login-container text-center">
                        <div className="form-login">
                            <form style={{height: 'inherit'}}>
                                <h4 className="text-center bold" style={{fontSize: 30}}>{title}</h4>
                                {body}
                                <div className={"row thin-row"}>
                                    <div className={"col s12 input-field input-grey"}>
                                        <label className="active">Contraseña actual</label>
                                        <input placeholder={"Ingrese su contraseña actual"} value={this.state.password} type={"password"}
                                               onChange={(ev) => this._handleInput('password', ev.target.value)} autocomplete="off"/>
                                    </div>
                                    <div className={"col s12 input-field input-grey"}>
                                        <label className="active">Nueva contraseña</label>
                                        <input placeholder={"Ingrese su nueva contraseña"} value={this.state.new_password1} type={"password"}
                                               onChange={(ev) => this._handleInput('new_password1', ev.target.value)} autocomplete="off"/>
                                    </div>
                                    <div className={"col s12 input-field input-grey"}>
                                        <label className="active">Repetir contraseña</label>
                                        <input placeholder={"Repita su nueva contraseña"} value={this.state.new_password2} type={"password"}
                                               onChange={(ev) => this._handleInput('new_password2', ev.target.value)} autocomplete="off"/>
                                    </div>
                                </div>
                                {!this.state.ajaxInProgress &&
                                <div className={"row"}>
                                    <div className={"col s12"}>
                                        <button onClick={this._handleSubmit} className={`btn btn-shell z-depth-0`}>
                                            Enviar
                                        </button>
                                    </div>
                                </div>
                                }
                                {!forcedRoute && !this.state.ajaxInProgress &&
                                <div>
                                    <Link to='/' className="text-center shell-red-text" style={{fontSize: 16}}>
                                        Volver al inicio</Link>
                                </div>
                                }
                                {this.state.ajaxInProgress &&
                                <div className={"row"}><Spinner /></div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
                <NotificationSystem ref="notificationSystem"/>
            </div>

        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

export default connect(mapStateToProps)(PasswordReset);



// WEBPACK FOOTER //
// ./src/containers/PasswordReset/passwordReset.js